import React from "react";
import { RiAddFill, RiDeleteBinLine } from "react-icons/ri";
import { TbCamera, TbEditCircle, TbPencil, TbUserEdit } from "react-icons/tb";
import {
  Button,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../ppui";
import { Snackbar } from "../../ppui/snackbar";
import { getDateProperFormatForInput } from "../../utils/common";
import { safeString } from "../../utils/logger";
import { BONUS_STATUS_FIELDS } from "../organization/benefit/benefit-constant";
import useBenifitService from "../organization/benefit/use-benefit-service";
import { INDUSTRY_TYPE, ORGANIZATION_CATEGORY, ORGANIZATION_FORM_FIELDS } from "../organization/profile/profile-contants";
import useOrganisationService from "../organization/profile/use-profile-service";
import { OrganizationBx, OrganizationEmDetails, PhotoIcon, PhotoUpload } from "../style";
import useOrgDetailsService from "./use-orgdetails-service";

function OrgPersonalDetails() {
  const { orgDetails, allState ,fetchOrgDetailsData} = useOrgDetailsService()

  // State for each modal's visibility
  const [openDetailsModal, setOpenDetailsModal] = React.useState(false);
  const [openActModal, setOpenActModal] = React.useState(false);
  const [openAddressModal, setOpenAddressModal] = React.useState(false);
  const [openBenefitsModal, setOpenBenefitsModal] = React.useState(false);

  // Details modal
  const handleOpenDetailsModal = () => setOpenDetailsModal(true);
  const handleCloseDetailsModal = () => setOpenDetailsModal(false);

  // Act modal
  const handleOpenActModal = () => setOpenActModal(true);
  const handleCloseActModal = () => setOpenActModal(false);

  // Organization Address modal
  const handleOpenAddressModal = () => setOpenAddressModal(true);
  const handleCloseAddressModal = () => setOpenAddressModal(false);

  // Organization Benefits modal
  const handleOpenBenefitsModal = () => setOpenBenefitsModal(true);
  const handleCloseBenefitsModal = () => setOpenBenefitsModal(false);

  function getOrganizationCategoryName(id) {
    const category = ORGANIZATION_CATEGORY.find(item => item.id === id);
    return category ? category.name : 'N/A';
  }
  function getOrganizationIndustryType(id) {
    const industryType = INDUSTRY_TYPE.find(item => item.id === id);
    return industryType ? industryType.name : 'N/A';
  }
  function getStateName(id) {
    const stateName = allState.find(item => item.id === id);

    return stateName ? stateName?.name : 'N/A'
  }




  const {
    orgProfile,
    handleClick,
    orgAcName,
    handleChange,
    handleAddRow,
    handleDeleteRow,
    fileInputRef,
    setPreviewURL,
    setSelectedFile,
    previewURL,
    stateList,
    setOrgProfile,
    createUpdateLoading,
    getInputFieldProps,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    getProfileLoading,
    openSnackbar
  } = useOrganisationService();

  const {
    handleChangeFunction,
    onSubmit,
    errors,
    benifitData,
    // createUpdateLoading: createUpdateLoadingBenifit,
    // snackbarVisible: snackbarVisibleBenifit,
    // snackbarMessage: snackbarBenifit,
    // closeSnackbar: closeSnackbarBenifit,
    // snackColor: snackColorBenifit,
  } = useBenifitService();

  if (getProfileLoading) {
    return <div>Loading...</div>
  }
 
  return (
    <>
      {!orgProfile?.org_name ?


        <>


          <Typography variant="h5">Basic Information</Typography>
          <Row>
            <Col sm={12} md={"auto"}>
              <PhotoUpload
                onClick={() => {
                  if (fileInputRef.current) {
                    fileInputRef.current.click();
                  }
                }}
              >
                {!previewURL &&
                  <TbUserEdit />
                }
                <input
                  type="file"
                  id="image"
                  name="image"
                  onChange={(event) => {
                    const file = event.target.files[0]; // Get the selected file
                    if (file) {
                      // Check if the file size is within the 2 MB limit
                      const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
                      if (file.size > maxSizeInBytes) {
                        openSnackbar({
                          message: "File size should not exceed 2 MB.",
                          color: "danger",
                        });


                        return; // Stop if file is too large
                      }
                      const allowedTypes = ["image/jpeg", "image/jpg"];

                      if (!allowedTypes.includes(file.type)) {
                        openSnackbar({
                          message: "Only JPG files are allowed.",
                          color: "danger",
                        });
                        return; // Stop if the file type is not allowed
                      }

                      setSelectedFile(file);
                      setPreviewURL(URL.createObjectURL(file)); // Create a preview URL

                      setOrgProfile((prevUser) => ({
                        ...prevUser,
                        logo: file,
                      }));
                    }
                  }}
                  ref={fileInputRef}
                  accept=".jpg, image/jpeg"
                  hidden
                />
                {previewURL && <img src={previewURL} alt="" />}
                <PhotoIcon>
                  <FabButton size="xs" variant="contained" color="primary" icon={previewURL ? <TbEditCircle /> : <TbCamera />} />
                </PhotoIcon>
              </PhotoUpload>
            </Col>
            <Col col-xs={"auto"}>
              <Row rowGap>

                <Col sm={12} md={6} lg={6} xxl={4} >
                  <InputField
                    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.org_name.name)}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4} >
                  <InputField
                    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.domain_name.name)}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4} >
                  <InputField
                    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.phone.name)}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4} >
                  <InputField
                    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.landline.name)}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4} >
                  <InputField
                    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.email.name)}
                  />
                </Col>

              </Row>
            </Col>
          </Row>

          <Divider gap={20} />
          <Typography variant="h5">Organization Details</Typography>
          <Row rowGap>

            <Col sm={12} md={6} lg={4} xxl={3} >
              <SelectField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.registration_type.name)}
              />
            </Col>
             <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.domain_name.name)}
            />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <SelectField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.industry_type.name)}

              // defaultValue='option1'
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.pan.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.tan_no.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.date_of_org.name)}
                valueSinc
                onKeyDown={e => e.preventDefault()}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3} >
              <SelectField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.payment_type.name)}
              />
            </Col>
            {safeString(orgProfile.payment_type).toLowerCase() === 'wages' && <Col sm={12} md={6} lg={4} xxl={3} >
              <SelectField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.wages_type.name)}
              />
            </Col>
            }

          </Row>

          <Divider gap={20} />
          <Typography variant="h5">Organization Address</Typography>
          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.address.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.city.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <SelectField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.state.name)}

                options={stateList || []}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <SelectField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.country.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.pincode.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.locality.name)}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3} >
              <InputField
                {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.landmark.name)}
              />
            </Col>

          </Row>

          <Divider gap={20} />
          <Typography variant="h5">Organisation Act Name</Typography>
          <Flex direction="column" gap={20}>
            {orgAcName?.map((item, index) => (
              <Row rowGap key={index}>
                <Col lg={8} xxl={6}>
                  <Row>
                    <Col sm={12} md={6}>
                      <InputField
                        fullWidth
                        label="Act Name"
                        placeholder="Type Here..."
                        type="text"
                        value={item.actName}
                        onChange={(e) =>
                          handleChange(index, "actName", e.target.value)
                        }
                        valueSinc={!!item.actName}
                      />
                    </Col>
                    <Col sm={12} md={6}>
                      <InputField
                        fullWidth
                        label="Reg No."
                        placeholder="Type Here..."
                        type="text"
                        value={item.regNo}
                        onChange={(e) =>
                          handleChange(index, "regNo", e.target.value)
                        }
                        valueSinc={!!item.regNo}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col sm={"auto"}>
                  <Flex gap={10}>
                    {index === orgAcName.length - 1 && (
                      <FabButton
                        color="primary"
                        icon={<RiAddFill />}
                        onClick={handleAddRow}
                        shape="box"
                        variant="outlined"
                      />
                    )}

                    <FabButton
                      color="primary"
                      icon={<RiDeleteBinLine />}
                      onClick={() => handleDeleteRow(index)}
                      disabled={orgAcName.length === 1 && true}
                      shape="box"
                      variant="outlined"
                    />
                  </Flex>
                </Col>
              </Row>
            ))}
          </Flex>

          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button onClick={() => { }} variant="outlined">
              Cancel
            </Button>
            <Button
              color="primary"
              type="button"
              onClick={handleClick}
              variant="contained"
              loading={createUpdateLoading}
            >
              Save
            </Button>
            <Snackbar
              message={snackbarMessage}
              color={snackColor}
              variant="contained"
              size="medium"
              position="top-right"
              onClose={
                closeSnackbar}
              onOpen={snackbarVisible}
              loading={false}
              duration={3000}
            />
          </Flex>

        </>

        : <>

          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="h5" mb={"0"}>
              Organization Details
            </Typography>

            <FabButton
              size="sm"
              icon={<TbPencil />}
              onClick={handleOpenDetailsModal}
              variant="filled"
              shape="box"
            />
          </Flex>
          <Gap height={30} />
          <OrganizationEmDetails>
            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Organization Category
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {getOrganizationCategoryName(orgDetails?.registration_type) || 'N/A'}
              </Typography>
            </OrganizationBx>
            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Industry Type
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {getOrganizationIndustryType(orgDetails?.industry_type) || 'N/A'}
              </Typography>
            </OrganizationBx>
            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Organization PAN
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.pan || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Organization TAN
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.tan_no || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Date Of Establishment
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {getDateProperFormatForInput(orgDetails?.date_of_org) || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Payment Type
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.payment_type ?? 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Salary Type
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.payment_type || 'N/A'}
              </Typography>
            </OrganizationBx>
          </OrganizationEmDetails>

          <Divider gap={20} />
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="h5" mb={"0"}>
              Organisation Act Name
            </Typography>

            <FabButton
              size="sm"
              icon={<TbPencil />}
              onClick={handleOpenActModal}
              variant="filled"
              shape="box"
            />
          </Flex>
          <Gap height={30} />
          {orgDetails?.org_acts?.map((item, index) => (
            <>
              <OrganizationEmDetails key={index}>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Act Name
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {item?.act_name || 'N/A'}
                  </Typography>
                </OrganizationBx>

                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Reg No.
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary">
                    {item?.reg_no || 'N/A'}
                  </Typography>
                </OrganizationBx>
              </OrganizationEmDetails>
            </>
          ))}
          <Divider gap={20} />
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="h5" mb={"0"}>
              Organization Address
            </Typography>

            <FabButton
              size="sm"
              icon={<TbPencil />}
              onClick={handleOpenAddressModal}
              variant="filled"
              shape="box"
            />
          </Flex>
          <Gap height={30} />
          <OrganizationEmDetails>
            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Address
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.address || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                City/District
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.city || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                State
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {getStateName(orgDetails?.state)}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Country
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.country || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Pin Code
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.pincode || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Locality
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.locality || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Landmark
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {orgDetails?.landmark || 'N/A'}
              </Typography>
            </OrganizationBx>
          </OrganizationEmDetails>
          <Divider gap={20} />
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="h5" mb={"0"}>
              Organization Benefits Details
            </Typography>

            <FabButton
              size="sm"
              icon={<TbPencil />}
              onClick={handleOpenBenefitsModal}
              variant="filled"
              shape="box"
            />
          </Flex>
          <Gap height={30} />
          <OrganizationEmDetails>
            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Bonus Status
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
                {benifitData?.bonus_status === true ? "Yes" : benifitData?.bonus_status === false ? "No" : "N/A" || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Ex Gratia
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
              {benifitData?.ex_gratia === true ? "Yes" : benifitData?.ex_gratia === false ? "No" : "N/A" || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Incentive Application
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
              {benifitData?.incentive_application === true ? "Yes" : benifitData?.incentive_application === false ? "No" : "N/A" || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                OT Application
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
              {benifitData?.ot_application === true ? "Yes" : benifitData?.ot_application === false ? "No" : "N/A" || 'N/A'}
              </Typography>
            </OrganizationBx>

            <OrganizationBx>
              <Typography variant="body2" mb={"0"}>
                Labour Welfare Fund
              </Typography>
              <Typography variant="body1" mb={"0"} color="primary">
              {benifitData?.labour_welfare_fund === true ? "Yes" : benifitData?.incentilabour_welfare === false ? "No" : "N/A" || 'N/A'}
              </Typography>
            </OrganizationBx>
          </OrganizationEmDetails>

          <Gap height={50} />


        </>}

      {/* Organization-Details-Modal */}
      <Dialog
        title="Organization Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openDetailsModal}
        onClose={handleCloseDetailsModal}
        onSubmit={()=>handleClick(handleCloseDetailsModal,fetchOrgDetailsData)}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <SelectField    {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.registration_type.name)}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.industry_type.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.pan.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.tan_no.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.date_of_org.name)}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.payment_type.name)}
            />
          </Col>
        </Row>
      </Dialog>
      {/* Organization-Details-Modal */}

      {/* Organization-Act-Modal */}
      <Dialog
        title="Organisation Act Name"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openActModal}
        onClose={handleCloseActModal}
        onSubmit={()=>handleClick(handleCloseActModal,fetchOrgDetailsData)}
        separator
      >
        {orgAcName?.map((item, index) => (
          <Row rowGap key={index} mb={20}>
            <Col sm={9} >
              <Row>
                <Col sm={6}>
                  <InputField
                    fullWidth
                    label="Act Name"
                    placeholder="Type Here..."
                    type="text"
                    value={item.actName}
                    onChange={(e) =>
                      handleChange(index, "actName", e.target.value)
                    }
                    valueSinc={!!item.actName}
                  />
                </Col>
                <Col sm={6}>
                  <InputField
                    fullWidth
                    label="Reg No."
                    placeholder="Type Here..."
                    type="text"
                    value={item.regNo}
                    onChange={(e) =>
                      handleChange(index, "regNo", e.target.value)
                    }
                    valueSinc={!!item.regNo}
                  />
                </Col>
              </Row>
            </Col>

            <Col sm={3}>
              <Flex gap={10}>
                {index === orgAcName.length - 1 && (
                  <FabButton
                    color="primary"
                    icon={<RiAddFill size={"small"} />}
                    onClick={handleAddRow}
                    shape="box"
                    variant="outlined"
                  />
                )}
                <FabButton
                  color="primary"
                  icon={<RiDeleteBinLine />}
                  onClick={() => handleDeleteRow(index)}
                  shape="box"
                  variant="outlined"
                />
              </Flex>
            </Col>
          </Row>
        ))}
      </Dialog>
      {/* Organization-Act-Modal */}

      {/* Organization-Address-Modal */}
      <Dialog
        title="Organization Address"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openAddressModal}
        onClose={handleCloseAddressModal}
        onSubmit={()=>handleClick(handleCloseAddressModal,fetchOrgDetailsData)}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.address.name)}
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.city.name)}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.state.name)}
              options={stateList || []}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.country.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.pincode.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.locality.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.landmark.name)}
            />
          </Col>
        </Row>
      </Dialog>
      {/* Organization-Address-Modal */}

      {/* Organization-Benefits-Modal */}
      <Dialog
        title="Organization Benefits Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openBenefitsModal}
        onClose={handleCloseBenefitsModal}
        onSubmit={()=>onSubmit(handleCloseBenefitsModal)}
        separator
      >
        {/* <Row rowGap>
          <Col sm={6}>

            <SelectField
              fullWidth
              label="Bonus Status"
              name="Bonus_Status"
              options={[
                { id: "option1", name: "Yes" },
                { id: "option2", name: "No" },
              ]}
              placeholder="Select Here..."
            />

          </Col>

          <Col sm={6}>

            <SelectField
              fullWidth
              label="Ex Gratia"
              name="Bonus_Status"
              options={[
                { id: "option1", name: "Yes" },
                { id: "option2", name: "No" },
              ]}
              placeholder="Select Here..."
            />

          </Col>

          <Col sm={6}>

            <SelectField
              fullWidth
              label="Incentive Application"
              name="Bonus_Status"
              options={[
                { id: "option1", name: "Yes" },
                { id: "option2", name: "No" },
              ]}
              placeholder="Select Here..."
            />

          </Col>

          <Col sm={6}>

            <SelectField
              fullWidth
              label="OT Application"
              name="Bonus_Status"
              options={[
                { id: "option1", name: "Yes" },
                { id: "option2", name: "No" },
              ]}
              placeholder="Select Here..."
            />

          </Col>

          <Col sm={6}>

            <SelectField
              fullWidth
              label="Labour Welfare Fund"
              name="Bonus_Status"
              options={[
                { id: "option1", name: "Yes" },
                { id: "option2", name: "No" },
              ]}
              placeholder="Select Here..."
            />

          </Col>
        </Row> */}
        <Row rowGap>
          {BONUS_STATUS_FIELDS.map((fieldProps) => {
            if (!errors[fieldProps.name]) {
              fieldProps.error = false;
              fieldProps.helperText = null;
            } else {
              fieldProps.error = !!errors[fieldProps.name];
              fieldProps.helperText = errors[fieldProps.name];
            }

            fieldProps.value = benifitData[fieldProps.name];
            fieldProps.defaultValue = benifitData[fieldProps.name];
            fieldProps.valueSinc = benifitData[fieldProps.name];

            if (fieldProps.inputType === "selectField") {
              return (
                <Col sm={12} md={6} lg={4} xxl={3} key={fieldProps.name}>
                  <SelectField
                    {...fieldProps}
                    onChange={(newValue) =>
                      handleChangeFunction(
                        newValue,
                        fieldProps.name,
                        fieldProps.customOptions
                      )
                    }
                  />
                </Col>
              );
            } else if (fieldProps.inputType == "dateField") {
              return (
                <Col sm={12} md={6} lg={4} xxl={3} key={fieldProps.name}>
                  <InputField
                    value={new Date(benifitData[fieldProps.name])}
                    fullWidth
                    {...fieldProps}
                    valueSinc
                    onChange={(e) =>
                      handleChangeFunction(e, null, fieldProps.customOptions)
                    }
                  />
                </Col>
              );
            } else {
              return (
                <Col sm={12} md={6} lg={4} xxl={3} key={fieldProps.name}>
                  <InputField
                    {...fieldProps}
                    onChange={(e) =>
                      handleChangeFunction(e, null, fieldProps.customOptions)
                    }
                  />
                </Col>
              );
            }
          })}
        </Row>
      </Dialog>
      {/* Organization-Benefits-Modal */}
    </>
  );
}

export default OrgPersonalDetails;
